import request from '@utils/request'

export function fetchFeesets(params) {
  return request({
    url: `/admin/pg/feeset`,
    params,
  })
}

export function fetchFeeset(seq) {
  return request({
    url: `/admin/pg/feeset/${seq || 0}`,
    method: 'get',
  })
}

export function createFeeset(data) {
  return request.post('/admin/pg/feeset', data)
}

export function updateFeeset(data) {
  return request.put(`/admin/pg/feeset/${data.seq}`, data)
}

export function setDefaultFeeset(seq) {
  return request.patch(`/admin/pg/feeset/${seq}`, {
    type: 'SET_DEFAULT',
  })
}

export function deleteFeeset(seq) {
  return request.delete(`/admin/pg/feeset/${seq}`)
}

export function fetchFeesetFees(feeset_seq) {
  return request({
    url: `/admin/pg/feeset/${feeset_seq}/fee`,
  })
}

export function fetchFee(seq) {
  return request({
    url: `/admin/pg/fee/${seq || 0}`,
    method: 'get',
  })
}

export function createFee(data) {
  return request.post('/admin/pg/fee', data)
}

export function updateFee(data) {
  return request.put(`/admin/pg/fee/${data.seq}`, data)
}

export function deleteFee(seq) {
  return request.delete(`/admin/pg/fee/${seq}`)
}

export function fetchMerchantList(params) {
  return request({
    url: '/admin/pg/merchant',
    method: 'get',
    params,
  })
}

export function fetchMerchant(seq) {
  return request({
    url: `/admin/pg/merchant/${seq || 0}`,
    method: 'get',
  })
}

export function createMerchant(data) {
  return request.post('/admin/pg/merchant', data)
}

export function updateMerchant(data) {
  return request.put(`/admin/pg/merchant/${data.seq}`, data)
}

export function fetchTransactionList(params) {
  return request({
    url: '/admin/pg/transaction',
    method: 'get',
    params,
  })
}

export function fetchTransaction(seq) {
  return request({
    url: `/admin/pg/transaction/${seq || 0}`,
    method: 'get',
  })
}
